import { mapState, mapActions, mapMutations } from 'vuex';
import { getLoginInfo } from '@/util/platform/index';

export default {
  computed: {
    ...mapState('marketing/', ['pageConfig', 'loginInfo', 'userProfile']),
    isLogin() {
      return !!this.loginInfo.access_token
    },
    token() {
      const { token_type = 'Bearer', access_token } = this.loginInfo
      return token_type && access_token
        ? `${token_type} ${access_token}`
        : undefined
    }
  },
  methods: {
    ...mapActions('marketing/', ['generateUniqueKey', 'getLoginUserInfo']),
    ...mapMutations('marketing/', ['setLoginInfo', 'setUserProfile']),
    async checkUser(autoJump = false, uniqueKeyParams) {
      try {
        const params = { autoJump }

        if (uniqueKeyParams && autoJump) {
          const loginUniqueKey = await this.genLoginUniqueKey(uniqueKeyParams)
          params.customQuery = { uniqueKey: loginUniqueKey }
        }

        const res = await getLoginInfo(params)

        if (!res || !res.data || !res.data.access_token) {
          throw res
        }

        this.setLoginInfo(res.data)
      } catch (e) {
        console.log('[checkUser] error: ', e)
        this.setLoginInfo({})
      }
    },
    async genLoginUniqueKey(params = { campaignCode: this.pageConfig.campaignSourceCode }) {
      try {
        const res = await this.generateUniqueKey(params);

        return res.data
      } catch (e) {
        console.log('[genLoginUniqueKey] error: ', e)
      }
    },
    async getUserProfile() {
      try {
        if (!this.token) {
          throw new Error('token is empty')
        }

        const res = await this.getLoginUserInfo({ headers: { authorization: this.token } })
        this.setUserProfile(res.data)
      } catch (e) {
        this.setUserProfile({})
        console.log('[getProfileByToken] error: ', e)
      }
    },
  }
}


// WEBPACK FOOTER //
// ./src/views/marketing/mixin/login.js